import React, { Component } from 'react';

import '../Comprobantes.css';
import ComplementoPagos from './complementos/ComplementoPagos';

class ComprobantePago extends Component {
  state = {};

  handleOnComplementoChange = (event, showPagosForm = false) => {
    const { data } = this.props;
    const { Complemento = {} } = data;

    let complementos = {
      ...Complemento,
      ...event,
    };

    const newData = {
      ...data,
      Complemento: complementos,
    };

    this.props.onChange(newData, showPagosForm);
  };

  render() {
    const { showForm, data } = this.props;

    return (
      <ComplementoPagos
        showForm={showForm}
        data={data}
        onChange={this.handleOnComplementoChange}
      />
    );
  }
}

export default ComprobantePago;
